<template>
  <div>
    <div v-if="email_changed" class="h5n bold center warning m0 mt3">Vous ne pouvez pas modifier l'e-mail</div>
    <div v-if="error_1" class="h5n bold center warning m0 mt3">Veuillez utiliser des informations de contact différentes.</div>

    <GenerateForm :form="form" :data="data" :save-action="saveData" />
  </div>
</template>

<script>

import { reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { getUser, createContact, updateContact } from '@/mixins/requests';
import { isInImpersonateModeNotification } from '@/mixins/utils';
import GenerateForm from '@/components/common/GenerateForm';

export default {
  components: { GenerateForm },
  setup () {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const email_changed = ref(false);
    const error_1 = ref(false);

    const data = reactive({ ...(store.state.contacts.find(u => u.uuid === route.params.uuid) || {}) });
    const form = reactive([
      [
        { label: 'Civilité', id: 'gender', type: 'select', class: 'col-12 sm-col-6', required: true, options: [{ value: 'mr', text: 'M.' }, { value: 'mme', text: 'Mme' }], rules: ['required', 'option'] },
        { label: 'Date de naissance', id: 'birth_date', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: 'Ex: 27/03/1980', mask: '##/##/####' }
      ],
      [
        { label: 'Prénom', id: 'firstname', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: 'Prénom' },
        { label: 'Nom', id: 'lastname', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: 'Nom' }
      ],
      [{ label: 'Email', id: 'email', type: 'text', class: 'col-12', required: true, placeholder: 'Email', disabled: data.uuid }]
    ]);

    async function saveData () {
      email_changed.value = false;
      error_1.value = false;
      if (isInImpersonateModeNotification()) {
        return;
      }
      store.commit('setLoading', true);
      let response = null;

      if (data.uuid) {
        const contact = store.state.contacts.find(u => u.uuid === route.params.uuid);
        if (contact) {
          if (data.email !== contact.email) {
            email_changed.value = true;
          } else {
            response = await updateContact({ ...data, email: contact.email, parentUuid: store.state.user.uuid });
          }
        }
      } else {
        response = await createContact(data, store.state.user.uuid);
      }
      if (response) {
        if (response.code === 'ERROR_1' || response.code === 'ERROR_2') {
          error_1.value = true;
        } else if (response.success) {
          // Sync user data
          await getUser();

          router.replace({ name: 'MyContacts' });
        }
      }

      store.commit('setLoading', false);
      // if (user) {
      //  this.user = user;
      // }
    }

    return { data, form, email_changed, error_1, saveData };
  }
};
</script>

<style>
.input-height {
  height: 50px;
}

</style>
